import api from '../api'

const baseUrl = '/university/api/AdminPackage'

const moocPackageProvider = {
  getPackageCourseTable(params) {
    return api.post(`${baseUrl}/CourseTable`, params)
  },
  getPackage(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  getAllPackageUsers(params = {}) {
    return api.post(`${baseUrl}/PeopleTable`, {
      params,
    })
  },

  getInputs() {
    return api.get(`${baseUrl}/Input`)
  },

  addPackage(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  getAvailableStatus(params) {
    return api.post(`${baseUrl}/AvailableStatus`, params)
  },

  updateAvailableStatus(params) {
    return api.put(`${baseUrl}/EditStatus`, params)
  },

  updatePackage(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deletePackage(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },

  deletePackageCourse(params = {}) {
    return api.delete(`${baseUrl}/DeleteCourse`, { data: params })
  },

  searchPackageCourse(params) {
    return api.post(`${baseUrl}/SearchCourse`, params)
  },

  addPackageCourse(params) {
    return api.post(`${baseUrl}/AddCourse`, params)
  },

  updateUserRole(params = {}) {
    return api.put(`${baseUrl}/ProductPeopleRole`, params)
  },

  getAdminClassList(params) {
    return api.get(`${baseUrl}/AdminProductPeople/id?id=${params}`)
  },

  generateLoginUrl(params = {}) {
    return api.post(`/BizSchool/api/Home/LoginUrl`, params)
  },

  getTrainUsers(params) {
    return api.get(`${baseUrl}/PracticePeopleTable/id?id=${params}`)
  },

  updateUserTrainScore(params = {}) {
    return api.put(`${baseUrl}/PracticePeopleScore/id`, params)
  },
}

export default moocPackageProvider
